import moment from 'moment';

export function buildApiPayload({ payload, dateEndKeys }) {
  const newPayload = { ...payload };
  
  if (dateEndKeys && dateEndKeys.length) {
    for (const dateEndKey of dateEndKeys) {
      const date = payload[dateEndKey];
      
      if (date && moment(date, moment.ISO_8601, true).isValid() && /T\d{2}:\d{2}:\d{2}/.test(date)) {
        newPayload[dateEndKey] = adoptToApiDateEnd(date);
      }
    }
  }

  return newPayload;
}

export function adoptToApiDateEnd(date) {
  const dateMoment = moment.utc(date);
  const seconds = dateMoment.format('ss.SSS');

  if (seconds === '00.000') {
    return dateMoment.subtract(1, 'ms').toISOString();
  }

  return date;
}
